import { render, staticRenderFns } from "./DetalhesUsuario.vue?vue&type=template&id=f16d350a&scoped=true"
import script from "./DetalhesUsuario.vue?vue&type=script&lang=ts"
export * from "./DetalhesUsuario.vue?vue&type=script&lang=ts"
import style0 from "./DetalhesUsuario.vue?vue&type=style&index=0&id=f16d350a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16d350a",
  null
  
)

export default component.exports